import React from "react";
import { Stack, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import TokenitizeName from "./TokenitizeName";

const AuthHeader = () => {
  const navigate = useNavigate();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        position: "absolute",
        top: 30,
        width: "80%",
        maxWidth: 1200,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{
          cursor: "pointer",
          transition: "opacity 0.2s ease",
          "&:hover": { opacity: 0.8 },
        }}
        onClick={() => navigate("/")}
      >
        <ArrowBackIcon fontSize="small" />
        <Typography variant="body2">Back</Typography>
      </Stack>

      <TokenitizeName height={32} />
    </Stack>
  );
};

export default AuthHeader;
